import React, { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Text } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { InlineHelp } from '@bingads-webui-campaign-react/mca-inline-help';

import { StepFooter } from './step-footer';
import { getCardWrapperStyles } from '../styles/card-wrapper-styles';

export function CardWrapper(props) {
  const {
    children,
    className,
    title,
    titleHelpTopic,

    previousButtonLabel,
    nextButtonLabel,
    onPreviousClick,
    onNextClick,
    onCancelClick,
    isNextButtonDisabled,
    disableButtons,
  } = props;
  const classes = useDefaultStyles(getCardWrapperStyles);

  const renderCardHeader = useMemo(() => (
    <React.Fragment>
      { title &&
        <div className={classNames(classes.titleContainer, 'card-header-title')}>
          <Text
            block
            variant="xLarge"
            className="card-title"
          >
            {title}
          </Text>
          { titleHelpTopic &&
            <InlineHelp topic={titleHelpTopic} />
          }
        </div>
      }
    </React.Fragment>
  ), [classes.titleContainer, title, titleHelpTopic]);

  return (
    <div className={classNames('card-container', className, classes.cardContainer)}>
      <div className={classNames('card-header', classes.cardHeaderContainer)}>
        {renderCardHeader}
      </div>
      {children}
      <StepFooter
        previousButtonLabel={previousButtonLabel}
        nextButtonLabel={nextButtonLabel}
        onPreviousClick={onPreviousClick}
        onNextClick={onNextClick}
        onCancelClick={onCancelClick}
        isNextButtonDisabled={isNextButtonDisabled}
        disableButtons={disableButtons}
      />
    </div>
  );
}

CardWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  titleHelpTopic: PropTypes.string,

  previousButtonLabel: PropTypes.string,
  nextButtonLabel: PropTypes.string,
  onPreviousClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onNextClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onCancelClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  isNextButtonDisabled: PropTypes.bool,
  disableButtons: PropTypes.bool,
};

CardWrapper.defaultProps = {
  children: null,
  className: null,
  title: null,
  titleHelpTopic: null,

  previousButtonLabel: null,
  nextButtonLabel: null,
  onPreviousClick: null,
  onNextClick: null,
  onCancelClick: null,
  isNextButtonDisabled: false,
  disableButtons: false,
};
